import React, { useEffect, useState } from "react";

import { Circle, HorizontalContainer } from "./difficulty-cicles.styles";

const DifficutlyCircles = ({ difficulty, margin, circleBorder }) => {
	const [containerWidth, setContainerWidth] = useState(70);
	const [circleWidth, setCircleWidth] = useState(20);
	var containerHeight;
	var difficultyContainerRef;

	useEffect(() => {
		SetContainerWidth();
		SetCircleWidth();
	});

	const SetContainerWidth = () => {
		containerHeight = difficultyContainerRef.offsetHeight;
		// containerHeight = containerHeight - margin * 2;
		const containerWidth = (containerHeight * 4.65) / 1;
		setContainerWidth(containerWidth);
	};

	const SetCircleWidth = () => {
		setCircleWidth(containerHeight);
	};

	const CircleWithProps = props => (
		<Circle width={circleWidth} $circleBorder={circleBorder} {...props} />
	);
	const HorizontalContainerWithProps = ({ children }) => (
		<HorizontalContainer
			width={containerWidth}
			$margin={margin}
			ref={divElement => {
				difficultyContainerRef = divElement;
			}}
		>
			{children}
		</HorizontalContainer>
	);

	switch (difficulty) {
		case 2:
			return (
				<HorizontalContainerWithProps>
					<CircleWithProps />
					<CircleWithProps />
					<CircleWithProps $isEmpty />
					<CircleWithProps $isEmpty />
				</HorizontalContainerWithProps>
			);

		case 3:
			return (
				<HorizontalContainerWithProps>
					<CircleWithProps />
					<CircleWithProps />
					<CircleWithProps />
					<CircleWithProps $isEmpty />
				</HorizontalContainerWithProps>
			);
		case 4:
			return (
				<HorizontalContainerWithProps>
					<CircleWithProps />
					<CircleWithProps />
					<CircleWithProps />
					<CircleWithProps />
				</HorizontalContainerWithProps>
			);
		default:
			return (
				<HorizontalContainerWithProps>
					<CircleWithProps />
					<CircleWithProps $isEmpty />
					<CircleWithProps $isEmpty />
					<CircleWithProps $isEmpty />
				</HorizontalContainerWithProps>
			);
	}
};

export default DifficutlyCircles;
